import { eLivraisonHistorySourceType } from './shippinghistorysourcetype';

export class DtoShippinpHistory {
  
   ShippingID: number; // billnumexp
   CustomerID: number; 
   ExceptionCode: number; // billnonliv
   ExceptionCodeDesc: string;  // billnonliv desc
   ProcessedDate: Date; //billnonlivdate + billnonlivheure
   Note: string; // bill_note
   Note2: string; // bill_note2
   DateInsert: Date; // date_insert
   SourceType: eLivraisonHistorySourceType;
   UserID: number;
   sequence: number;
   ExceptionCodeValue: number;
   PostponedDate: Date; // Doesn't have a field in nationex.livraisonhistory yet
   SubException: number;

}


   
